export default __webpack_public_path__ + "static/media/appraisepicguide.cacdf071.png";